export default "__VITE_ASSET__DsJPrwYh__"